export { default as EN } from "./en.json";
export const HOME_NAMESPACE = "home";
